<template>
  <div class="mb2 mx1">
    <span v-if="label" class="bold h6n" :class="[{'caps': caps}, {'red': error}]">{{ label }}</span>

    <!-- DATE INPUT: field + calendar in popover (click), not inline grid -->
    <div
      v-if="type === 'date'"
      class="birth-date-picker-root"
    >
      <DatePicker
        v-model="dateModel"
        mode="date"
        :min-date="minDateForPicker"
        :max-date="maxDateForPicker"
        :initial-page="birthDatePickerInitialPage"
        :masks="{ input: 'DD/MM/YYYY' }"
        :popover="datePickerPopover"
        :update-on-input="true"
        :input-debounce="0"
      >
        <template #default="{ inputValue, inputEvents }">
          <input
            class="col-12 py1 h4n px2 border-radius-3 dark-grey-bd white-bg birth-date-input"
            type="text"
            autocomplete="off"
            :name="name"
            :placeholder="placeholder"
            :value="inputValue"
            :class="{ 'invalid-field': error }"
            v-on="inputEvents"
          >
        </template>
      </DatePicker>
    </div>

    <!-- TEXT, NUMBER, (...) INPUT -->
    <input
      v-else
      class="col-12 py1 h4n px2 border-radius-3 dark-grey-bd"
      :name="name"
      :type="type"
      :placeholder="placeholder"
      :pattern="pattern"
      :required="required"
      :value="value"
      :class="{'invalid-field': error}"
      @change="handleChange"
    >
    <span v-if="error" class="bold h6n red"> {{ error }}</span>
  </div>
</template>

<script>
import { format, parse, isValid } from 'date-fns';
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';

import { checkError } from '@/utils/utils';

export default {
  components: { DatePicker },
  props: {
    value: String,
    name: String,
    label: String,
    type: String,
    placeholder: String,
    pattern: String,
    required: Boolean,
    props: Object,
    error: {
      type: String,
      default: ''
    },
    caps: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      datePickerPopover: {
        placement: 'bottom',
        visibility: 'click'
      }
    };
  },
  computed: {
    minDateForPicker () {
      return this.props && this.props.minDate ? this.props.minDate : undefined;
    },
    maxDateForPicker () {
      return new Date();
    },
    dateModel: {
      get () {
        if (!this.value) return null;
        const d = parse(this.value, 'dd/MM/yyyy', new Date());
        return isValid(d) ? d : null;
      },
      set (v) {
        if (v == null || v === '') {
          this.$emit('update:value', null);
          this.$emit('change', { name: this.name, value: null });
          return;
        }
        const d = v instanceof Date ? v : new Date(v);
        if (!isValid(d)) return;
        const str = format(d, 'dd/MM/yyyy');
        this.$emit('update:value', str);
        this.$emit('change', { name: this.name, value: str });
      }
    },
    birthDatePickerInitialPage () {
      if (this.value) {
        const d = parse(this.value, 'dd/MM/yyyy', new Date());
        if (isValid(d)) {
          return { month: d.getMonth() + 1, year: d.getFullYear() };
        }
      }
      const t = new Date();
      return { month: t.getMonth() + 1, year: t.getFullYear() };
    }
  },
  methods: {
    checkError,
    handleChange (e) {
      const { target: { value, name } } = e;
      this.$emit('change', { name, value });
      this.$emit('update:value', value);
    }
  }
};
</script>

<style lang="scss" scoped>

  .invalid-field {
    border: 1px solid red;
  }

  .birth-date-input {
    cursor: text;
  }

  :deep(.vc-popover-content-wrapper) {
    z-index: 30;
  }
</style>
